<template>
  <div class="draftactivitymanagetable">
    <el-table
      :data="tableData"
      style="width: 100%;padding:10px 10px 0 10px;"
      border>
      <el-table-column
        prop="createAtMY"
        label="创建时间"
        width="160"
      >
      </el-table-column>
      <el-table-column
        prop="createName"
        label="发布人"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="title"
        label="活动标题"
      >
      </el-table-column>
      <el-table-column
        label="已收集图片"
        v-if="false"
      >
        <template slot-scope="scope">
          <div>
            {{scope.row.zhang}}张/{{scope.row.ren}}人投稿
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="65">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 1">
            <el-tag type="success">{{'开启'}}</el-tag>
          </div>

          <div v-if="scope.row.status === 0">
            <el-tag type="danger">{{'停用'}}</el-tag>
          </div>

          <div v-if="scope.row.status !== 0 && scope.row.status !== 1">
            <el-tag type="info">{{'无'}}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="400">
        <template slot-scope="scope">
          <div>
            <el-button @click="changeClick(scope)" type="text" style="color:#185ED3;font-weight:bold;font-size:13px;" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-edit-outline"></i>修改</el-button>
            <span style="margin:0 11px;"> | </span>
            <el-button @click="closeClick(scope)" v-if="scope.row.status === 1" style="color:#F96900;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-circle-close"></i>关闭</el-button>
            <el-button @click="closeClick(scope)" v-if="scope.row.status !== 1" style="color:#42CA5F;font-weight:bold;font-size:13px;" type="text" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-document-checked"></i>开启</el-button>
            
            <span v-if="scope.row.status !== 1" style="margin:0 11px;"> | </span>
            <el-button v-if="scope.row.status !== 1" @click="delectClick(scope)" type="text" style="color:#FF4545;font-weight:bold;font-size:13px;" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-delete"></i>删除</el-button>
            <span style="margin:0 11px;"> | </span>
            <el-button @click="linkClick(scope)" type="text" style="color:#3086F0;font-weight:bold;font-size:13px;" class="btn" size="small"><i style="margin-right:3px;" class="el-icon-link"></i>活动链接</el-button>
          </div>
          
        </template>
      </el-table-column>
    </el-table>


    <el-dialog width="28%" :before-close="handleClose" :visible.sync="mydialogVisible">
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>活动链接</div>
      </div>
      <div>
        <p style="margin-bottom:15px;">网页版： 
          <!-- <a href="javascript:;" target="_blank" onclick="javascript:openURL('http://www.kpdown.com/search?name=Ben%20Nadel');">{{pclink + id}}</a> -->
          <span style="color:#185ED3;cursor: pointer;" @click="openPc">{{pclink + id}}</span>
          </p>
        <!-- <p>手机版： <span style="color:#185ED3;">{{phonelink}}</span></p> -->
        <div style="width:100%;margin-top:20px;text-align:center;">
          <!-- <img src="@/assets/erweima.png" alt=""> -->
          <div ref="erweima" id="erweima" style="width:116px;height:116px;margin:0 auto;"></div>
          <p style="margin:5px 0 20px 0;">(移动端二维码)</p>
          <el-button @click="quit">关闭</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'  // 引入qrcode
import { getAppBaseConfig } from "@/api/config";
import { powersObj } from "@/constants/powers";
export default {
  name: 'draftactivitymanagetable',
  props: {
    tableData:Array,
    
  },
  data(){
    return {
      //权限
      powersObj,

      publicDomain:'',
      id:'',
      status:0,
      pclink:'',
      // pclink:'http://cdp-local-public.test.routeryuncs.com/activity?id=',
      phonelink:'https://www.baidu.phone.com',
      mydialogVisible:false
    }
  },
  methods:{
    closeClick(scope){
      this.$emit('authClick',scope)
    },
    changeClick(scope){
      this.$emit('changeClick',scope)
    },
    delectClick(scope){
      this.$emit('delectClick',scope)
    },
    linkClick(scope){
      if(this.publicDomain){
        this.id = scope.row.id
        this.mydialogVisible=true
        this.status = scope.row.status
        setTimeout(() => {
          this.$refs.erweima.innerHTML = ''
          let baseUrl = this.publicDomain
          // let baseUrl = 'http://192.168.187.195:8081/activity'
          let id =  this.id
          let token = localStorage.getItem('token')
          token = token.slice(1)
          token = token.substring(0,token.length - 1)
          let hf = baseUrl + '/homeActivity/show' + '?id=' +  id
          let hfm = baseUrl + '/mobile/white' + '?id=' +  id + '&status=' + this.status
          // let hf = baseUrl + '?id=' +  id + '&status=' + this.status
          this.pclink = baseUrl + '?id='

          // console.log(hf);
          if(this.mydialogVisible){
            let qrcode = new QRCode('erweima', {
              width: 116,  
              height: 116,
              text: hfm, // 二维码地址
            })
          }
        }, 500);
      }else{
        this.$message.warning('请管理员配置相关参数！')
      }
      
      
    },

    quit(){ this.mydialogVisible=false },
    handleClose(){ this.mydialogVisible=false },
    openPc(){
      
      // let baseUrl = this.publicDomain + '/activity'
      let baseUrl = this.publicDomain + '/homeActivity/show'
        // let baseUrl = 'http://192.168.187.195:8081/activity'
      let id =  this.id
      let token = localStorage.getItem('token')
      token = token.slice(1)
      token = token.substring(0,token.length - 1)
      let date = new Date()
      // let hf = baseUrl + '?id=' +  id + '&status=' + this.status + '&time=' + date.getTime()
      let hf = baseUrl + '?id=' +  id + '&status=' + this.status + '&time=' + date.getTime()
      window.open(hf)
    },
    //获取应用基础配置
    async getAppBaseConfigAsync() {
      let { status, data, message } = await getAppBaseConfig();
      if(status){
        this.publicDomain = data.publicDomain
      }
    },
  },
  created(){
    this.getAppBaseConfigAsync()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
.table{
  width: auto;
}
.btn:hover{
  text-decoration: underline;
}
</style>
